<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { KendoChart } from "@Kendo/Components/KendoChart";
    import { CriterionSelectorDialogViewModel } from "@Criteria/Hierarchies/Components/CriterionSelectorDialog";
    import CriterionSelectorDialog from "@Criteria/Hierarchies/Components/CriterionSelectorDialog.vue";
    import { SensitivityAnalysisChartDialogViewModel } from "@Evaluation/ValueAnalysis/Components/SensitivityAnalysisChartDialog";

    @Component({
        components:{
            CriterionSelectorDialog
        },
        props: {
            viewModel: { type: Object, required: true }
        }
    })
    export default class SensitivityAnalysisChartDialog extends Vue
    {
        get vm(): SensitivityAnalysisChartDialogViewModel { return this.$props.viewModel as SensitivityAnalysisChartDialogViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
        get chart(): KendoChart { return this.vm.chart; }
        get selectedCriterionName(): string { return this.vm.selectedCriterion?.Name ?? null; }
        get goalSelected(): boolean { return this.vm.goalSelected; }

        get criterionId(): number { return this.vm.criterionId; }
        set criterionId(val: number) { this.vm.criterionId = val; }

        criterionSelectorDialog: CriterionSelectorDialogViewModel = new CriterionSelectorDialogViewModel();

        showCriterionSelector()
        {
            this.criterionSelectorDialog.show(this.criterionId, this.vm.criteria);
        }

        handleChangeCriterion(criterionId: number)
        {
            if (criterionId !== this.criterionId)
            {
                this.criterionId = criterionId;
                this.vm.setChartData();
            }
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div>
        <div class="modal-mask" v-if="opened">
            <div class="modal-wrapper">
                <div class="modal-dialog modal-xl modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Sensitivity analysis</h5>
                            <button type="button" class="close" @click="close">&times;</button>
                        </div>

                        <div class="modal-body">
                            <div>
                                <p>Criterion: <a class="text-primary" @click="showCriterionSelector">{{selectedCriterionName}}</a></p>

                                <div class="alert alert-warning" role="alert" v-if="goalSelected">
                                    Please select a criterion. Sensitivity analysis in the context of root is not available.
                                </div>
                            </div>

                            <br />

                            <div style="max-height: calc(100vh-200px); overflow: auto;">
                                <div id="Chart-SensitivityAnalysisChart"></div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <CriterionSelectorDialog :viewModel="criterionSelectorDialog"
                                 @confirm-selection="handleChangeCriterion" />
    </div>

</template>

